jQuery(document).ready(function($) {

    // Attach the event to the search input
    $('.job-search').on('input', function() {
        var query = $(this).val();
        var suggestionBox = $(this).siblings('.job-search-suggestions');
        
        // Create suggestion box if it doesn't exist
        if (suggestionBox.length === 0) {
            suggestionBox = $('<ul class="job-search-suggestions"></ul>').insertAfter($(this));
        }

        if (query.length >= 3) {
            // Fetch suggestions from your data source (via AJAX)
            $.ajax({
                url: props.ajaxurl, // Use the localized AJAX URL
                type: 'POST',
                data: {
                    action: 'get_job_suggestions',
                    term: query,
                    nonce: props.nonce // Include the nonce in the request
                },
                success: function(response) {
                    suggestionBox.empty(); // Clear previous suggestions

                    if (response.length) {
                        $.each(response, function(index, suggestion) {
                            suggestionBox.append('<li class="suggestion-item" tabindex="0">' + suggestion + '</li>');
                        });

                        // Focus the first suggestion item after populating
                        // suggestionBox.find('li:first').focus();
                        $('.b__hero__home').removeClass('show-suggestions'); 
                    }
                },
                error: function(xhr, status, error) {
                    // console.log("AJAX Error: ", error); // Log the error
                }
            });
        } else {
            suggestionBox.empty(); // Clear suggestions if query is too short
            $('.b__hero__home').addClass('show-suggestions');
        }
    });

    // Handle keyboard navigation (use event delegation)
    $(document).on('keydown', '.suggestion-item', function(event) {

        // Handle enter key
        if (event.key === 'Enter') {
            var selectedItem = $(this).text();
            var searchInput = $(this).closest('form').find('.job-search');
            searchInput.val($(this).text());
            $(this).parent().empty(); // Hide suggestions after selection
            $('#search-submit').trigger('click');
            event.preventDefault(); // Prevent default action
        }

        // Handle arrow keys for navigating suggestions
        if (event.key === 'ArrowDown') {
            $(this).next().focus(); // Focus next item
        } else if (event.key === 'ArrowUp') {
            $(this).prev().focus(); // Focus previous item
        }
    });

    // Handle click on suggestion
    $(document).on('click', '.suggestion-item', function() {
        var searchInput = $(this).closest('form').find('.job-search');
        searchInput.val($(this).text());
        var form = $(this).closest('form');
        $(this).parent().empty(); // Hide suggestions after selection


        if( ! $(this).hasClass('location') ){
            if( $(form).hasClass('mobile-form') ){
                $('#search-submit-mobile').trigger('click');
            }else{
                $('#search-submit').trigger('click');
            }
        }
    });

    // Handle click on suggestion
    $(document).on('click', '#submit-trigger', function(e) {
        e.preventDefault();
        $('#search-submit').trigger('click');
    });

    // Close suggestion box when clicking outside
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.job-search, .job-search-suggestions').length) {
            $('.job-search-suggestions').empty(); // Close the suggestion box
        }
    });

    $('#get-location-mobile').on('click', function(e){
        e.preventDefault();
        $('#get-location').trigger('click');
    });

    // Proximity Search
    $('#get-location').on('click', function(e) {
        e.preventDefault(); // Prevent default link behavior
        
        // Check if the browser supports Geolocation
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var latitude = position.coords.latitude;
                var longitude = position.coords.longitude;
                
                // Display latitude and longitude
                $('#location-result').val(latitude + "," + longitude);
                $('#search-submit').trigger('click');
            }, function(error) {
                // Handle error cases
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        alert("User denied the request for Geolocation.");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        alert("Location information is unavailable.");
                        break;
                    case error.TIMEOUT:
                        alert("The request to get user location timed out.");
                        break;
                    case error.UNKNOWN_ERROR:
                        alert("An unknown error occurred.");
                        break;
                }
            });
        } else {
            // console.log("Geolocation is not supported by this browser.");
        }
    });

    $('#job-search').on('focus', function() {
        // Display a message or trigger any other action
        $('.b__hero__home').addClass('search-open');
        $('.b__hero__jobs').addClass('search-open');

        var query = $(this).val();

        if( query.length < 1 ){
            $('.b__hero__home').addClass('show-suggestions');
            $('.b__hero__jobs').addClass('show-suggestions');
        }

        if( query.length >= 3 ){
            $(this).trigger('input');
        }
    });

    $('#postcode-input').on('focus', function() {
        // Display a message or trigger any other action
        $('.b__hero__jobs').addClass('search-open');
    });

    // Close suggestion box when clicking outside
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.b__hero__search').length) {
            $('.b__hero__home').removeClass('search-open'); 
            $('.b__hero__home').removeClass('show-suggestions'); 
            $('.b__hero__jobs').removeClass('search-open'); 
            $('.b__hero__jobs').removeClass('show-suggestions'); 
        }
    });

    $(window).scroll(function () {
        $('.b__hero__home').removeClass('search-open');
        $('.b__hero__home').removeClass('show-suggestions');
        $('.b__hero__jobs').removeClass('search-open');
        $('.b__hero__jobs').removeClass('show-suggestions');
        $('.job-search-suggestions').empty();
        $('#job-search').blur();
        $('.b__hero__filters--toggle').prop('checked', false);
    });

    // Handle click on suggestion
    $(document).on('click', '.b__hero__search--suggestions--item', function(e) {
        e.preventDefault();
        var search = $(this).data('search');
        $('#job-search').val( search );
        $('#search-submit').trigger('click');
    });

    $(document).on('change', '.filters-checkbox', function(){
        var checkedValues = [];
        var filter = $(this).data( 'filter' );

        // Loop through each checked checkbox
        $('input[name="' + $(this).attr('name') + '"]:checked').each(function() {
            // Push the value of each checked checkbox into the array
            checkedValues.push($(this).val());
        });

        // Join the array into a string separated by commas
        var checkedValuesString = checkedValues.join(',');

        // Change the value of input[name="contract"]
        $('input[name="' + filter + '"]').val(checkedValuesString);

        if( $(this).hasClass('desktop') ){
            $('#job-search-form').submit();
        }
    });

    $(document).on('submit', '#job-search-form', function(e){
        e.preventDefault();

        // Create an array to hold the filled inputs
        var filledInputs = $(this).find(':input').filter(function() {
            return $.trim($(this).val()) !== ''; // Filter out empty inputs
        });

        // Build the query string
        var queryString = filledInputs.serialize();

        // Redirect to the action page with the query string
        window.location.href = $(this).attr('action') + '?' + queryString;
    });

    $(document).on('change', '.b__hero__filters--toggle', function(){
        $('.b__hero__filters--toggle').not($(this)).prop('checked', false);

        $('.b__hero__filters--toggle').each(function(){
            var checkboxID = $(this).attr('id');  // Get the ID of the checkbox
            var label = $('label[for="' + checkboxID + '"]');  // Get the label element using the checkbox ID
    
            if( $(this).is(':checked') ){
                label.attr('aria-expanded', 'true');  
            }else{
                label.attr('aria-expanded', 'false'); 
            }
        });

    });

    $(document).on('click', function(e) {
        // Check if the clicked target is NOT #accessibility-toggle or a child of it
        if (!$(e.target).closest('.b__hero__jobs__filters--item').length) {
            $('.b__hero__filters--toggle').prop('checked', false);
            $('.b__hero__filters--toggle').trigger('change');
        }
    });

    $(document).on('click', '.c__activeFilters label', function(e){
        e.preventDefault();
        var submit = true;

        if ( !$(this).attr('id') ) {
            var target = $(this).attr('for');

            $('#' + target).prop('checked', false);
            $('#' + target).trigger('change');

            if( $(this).hasClass('branch') ){
                $('#branch').val('');
            }
        }else{
            var id = $(this).attr('id');

            if( id == 'clear-all' ){
                var actionUrl = $('#job-search-form').attr('action'); // Get the URL from the action attribute
        
                if (actionUrl) {
                    submit = false;
                    window.location.href = actionUrl; // Redirect to the URL
                }
            }else if( id == 'clear-search'){
                $('#job-search').val('');
            }else if( id == 'clear-location' ){
                $('#location-result').val('');
                $('#radius-result').val('');
                $('#postcode-result').val('');
                $('#postcode-input').val('');
            }else if( id == 'clear-linked' ){
                $('#linked_page').val('');
            }else if( id == 'clear-country' ){
                $('#country').val('');
            }else if( id == 'clear-city' ){
                $('#city').val('');
            }else if( id == 'clear-employer-division' ){
                $('#employer_division').val('');
            }
        }

        if( submit ){
            $('#job-search-form').submit();
        }
    });

    $(document).on('click', '.search-toggle-mobile', function(){
        $('.mobile-search-toggle').trigger('click');
        $('.mobile-search-toggle').trigger('change');
    });

    $(document).on('change', '.mobile-search-toggle', function(){
        if( $(this).prop('checked') ){
            $('h5.search-toggle-mobile').addClass('open');
        }else{
            $('h5.search-toggle-mobile').removeClass('open');
        }

        // $('h5.search-toggle-mobile').toggleClass('open');
    });

    $(document).on('change', '.mobile-search-toggle', function(){
        var checkboxID = $(this).attr('id');  // Get the ID of the checkbox
        var label = $('label[for="mobile-search-toggle"]');  // Get the label element using the checkbox ID

        if( $(this).is(':checked') ){
            label.attr('aria-expanded', 'true');  
        }else{
            label.attr('aria-expanded', 'false'); 
        }
    });

    $(document).on('click', '#mobile-submit', function(){
        $('#search-submit-mobile').trigger('click');
    });

    $('.autocomplete').on('input', function () {
        var query = $(this).val();
        var suggestionBox = $(this).siblings('.autocomplete-suggestions');

        // Create suggestion box if it doesn't exist
        if (suggestionBox.length === 0) {
            suggestionBox = $('<ul class="autocomplete-suggestions job-search-suggestions"></ul>').insertAfter($(this));
        }

        if (query.length >= 3) {
            // Fetch suggestions from your data source (via AJAX)
            $.ajax({
                url: props.ajaxurl, // Use the localized AJAX URL
                type: 'POST',
                data: {
                    action: 'getpostcodes',
                    term: query,
                    nonce: props.nonce // Include the nonce in the request
                },
                success: function (response) {
                    suggestionBox.empty(); // Clear previous suggestions

                    // Parse response if needed
                    var data = typeof response === 'string' ? JSON.parse(response) : response;

                    if (data.length) {
                        // Populate suggestions
                        $.each(data, function (index, item) {
                            suggestionBox.append(
                                '<li class="suggestion-item location" data-lat="' +
                                    item.lat +
                                    '" data-lng="' +
                                    item.lng +
                                    '">' +
                                    item.label +
                                    '</li>'
                            );
                        });
                    } else {
                        suggestionBox.append('<li class="no-results">No suggestions found</li>');
                    }
                },
                error: function (xhr, status, error) {
                    console.error("AJAX Error: ", error);
                },
            });
        } else {
            suggestionBox.empty(); // Clear suggestions if query is too short
        }
    });

    // Handle click on suggestion items
    $(document).on('click', '.suggestion-item.location', function () {
        var selectedItem = $(this);
        var label = selectedItem.text();
        var lat = selectedItem.data('lat');
        var lng = selectedItem.data('lng');

        // Set the input value
        $('.autocomplete').val(label);
        $('#postcode-result').val(label);

        // Update Lat/Lng values or other behaviors
        updatePostcodeLatLngValues(lat, lng);

        // Clear the suggestion box
        selectedItem.parent('.autocomplete-suggestions').empty();

        $('#search-submit').trigger('click');
    });

    $(document).on('submit', '#postcode-form', function(e){
        e.preventDefault();

        $('#search-submit').trigger('click');
    });

    $(document).on('change', '#radius-dropdown', function(){
        $('#radius-result').val( $(this).val() );
        $('#search-submit').trigger('click');
    });

    $(document).on('keydown', '.b__hero__search--suggestions--item, .b__hero__search--suggestions--item *', function(e) {
        if (e.key === 'Enter') {
            $(this).closest('.b__hero__search--suggestions--item').trigger('click');
        }
    });


    function updatePostcodeLatLngValues(facetPostcodeLatVal, facetPostcodeLngVal)
    {

        $('#location-result').val(facetPostcodeLatVal + "," + facetPostcodeLngVal);

    }
});
